<template lang="pug">
.gu24-favorite(@click="click", :title="title" :class="{ 'gu24-favorite_active': value > 0 }")
  span.gu24-favorite__icon
  span.gu24-favorite__value
    slot {{ value }}
</template>

<script>
export default {
  name: 'FavoriteButton',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Избранное',
    },
    value: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.gu24-favorite {
  float: left;
  height: 100%;
  vertical-align: middle;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-size: 10 / 16 + rem;
  font-weight: 600;
  color: #fff;
  margin-right: 8 / 16 + rem;
  padding: 24 / 16 + rem 0 23 / 16 + rem 0;
  span {
    float: left;
    vertical-align: middle;
  }
  &:hover .gu24-favorite__icon {
    animation: like 1.5s ease infinite;
  }
  &__icon {
    width: 15 / 16 + rem;
    height: 13 / 16 + rem;
    margin-right: 6 / 16 + rem;
    background-image: url('./like.svg');
    background-size: contain;
    background-repeat: no-repeat;
  }
  &__value {
    font-size: 0;
  }
  &_active &__value {
    font-size: e-rem(10);
  }
  &_active &__icon {
    background-image: url('./like-fill.svg');
  }
}

@keyframes like {
  0% { transform: scale(1); }
  25% { transform: scale(1.4); }
  50% { transform: scale(0.75); }
  75% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>
